.button {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: var(--zumpo-space-8);
  height: 48px;
  margin: 0;
  padding: var(--zumpo-space-12) var(--zumpo-space-20);
  border: 0;
  border-radius: var(--zumpo-radius-16);
  background: var(--zumpo-coral);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition:
    box-shadow 120ms ease-out,
    transform 80ms ease-out;
}

/* Hover draws a 2 px ink border inside the button, so its size never moves. */
@media (hover: hover) {
  .button:hover:not([data-disabled]) {
    box-shadow: inset 0 0 0 2px var(--zumpo-ink);
  }
}

.button:active:not([data-disabled]) {
  transform: translateY(1px);
}

.button:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.button[data-disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}

.secondary {
  border: 1px solid var(--zumpo-line);
  background: var(--zumpo-paper);
}

@media (hover: hover) {
  .secondary:hover:not([data-disabled]) {
    border-color: var(--zumpo-ink);
    box-shadow: inset 0 0 0 1px var(--zumpo-ink);
  }
}

.quiet {
  background: var(--zumpo-cream);
}

.danger {
  background: var(--zumpo-danger);
  color: var(--zumpo-paper);
}

/* An icon-only button keeps its label for screen readers only. */
.iconOnly {
  padding: var(--zumpo-space-12);
}

.iconOnly .label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

@container (max-width: 560px) {
  .iconOnlyWhenNarrow {
    padding: var(--zumpo-space-12);
  }

  .iconOnlyWhenNarrow .label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}

@media (prefers-reduced-motion: reduce) {
  .button {
    transition: none;
  }

  .button:active:not([data-disabled]) {
    transform: none;
  }
}
